import { AuthenticationService } from './../../shared/authentication.service';
import { PacketDetails, SystemSetting } from './../../shared/configuration.model';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfigurationService } from '../../shared/configuration.service';
import { isNullOrUndefined } from 'util';
import { systemsettingsserviceService } from '../../shared/systemsettingsservice.service';

export interface PacketQueueCategory {
  value: string;
  viewValue: string;
}

export interface PacketType{
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-create-package-dialog',
  templateUrl: './create-package-dialog.component.html',
  styleUrls: ['./create-package-dialog.component.scss']
})


export class CreatePackageDialogComponent implements OnInit {

  packageName: string;
  packetTypeName: string = "";
  
  packetQueueCategoryValue: string = "";
  priorityvalue = 0;
  systemSettings: SystemSetting[] = [];
  hasStateIdentifier: boolean;
  stateIdentifierValue: string[];
  stateIdentifier: string;
  loading: boolean;
  screen: boolean;


  constructor(public dialogRef: MatDialogRef<CreatePackageDialogComponent>,
    public service: ConfigurationService,
    @Inject(MAT_DIALOG_DATA) public data: PacketDetails,
    public settingservice: systemsettingsserviceService,
    public auth: AuthenticationService) { 
    }

  packetQueueCategories: PacketQueueCategory[] = [
    { value: 'Internal', viewValue: 'Internal' },
    { value: 'External', viewValue: 'External' }
  ];
  packetTypes: PacketType[] = [
    { value: 'Attribute', viewValue: 'Attribute' },
    { value: 'QualityGroup', viewValue: 'QualityGroup' }
  ];
  ngOnInit() {
    
    this.loading = true;
    this.screen = true;
    if(!isNullOrUndefined(this.data)) {
      this.packageName = this.data.Name;
      this.priorityvalue = this.data.Priority;
      this.packetTypeName = this.data.GroupBy;
      this.packetQueueCategoryValue = this.data.QueueCategory;
  }
  
}

  OnCloseConfirm() {

    this.dialogRef.close({
      packageName: this.packageName, packetTypeName: this.packetTypeName,
      packetQueueCategory: this.packetQueueCategoryValue, priority: this.priorityvalue
    });
  }

  OnCloseCancel() {
    this.dialogRef.close('Cancel');
  }


}
